var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPoloniex = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 42,
    viewBox: "0 0 181 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9782_380350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.4167 29.7731V12.2236H62.1065C65.7806 12.2236 67.8281 14.7498 67.8281 17.7227C67.8281 20.6956 65.7559 23.2218 62.1065 23.2218H57.4868V29.7731H54.4167ZM61.6857 14.9335H57.4868V20.5119H61.6857C63.4187 20.5119 64.6764 19.4077 64.6764 17.7227C64.6764 16.0378 63.4162 14.9335 61.6857 14.9335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5343 11.9331C83.783 11.9331 87.4842 15.7746 87.4842 21.0106C87.4842 26.2466 83.783 30.0906 78.5343 30.0906C73.2857 30.0906 69.5844 26.2491 69.5844 21.0131C69.5844 15.777 73.2857 11.9331 78.5343 11.9331ZM78.5343 14.6703C74.9914 14.6703 72.7335 17.3801 72.7335 21.0131C72.7335 24.6187 74.9914 27.3558 78.5343 27.3558C82.0523 27.3558 84.335 24.6187 84.335 21.0131C84.335 17.3801 82.05 14.6703 78.5343 14.6703Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4478 29.7731V12.2236H93.5177V27.0632H101.232V29.7731H90.4478Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.388 11.9331C116.637 11.9331 120.338 15.7746 120.338 21.0106C120.338 26.2466 116.637 30.0906 111.388 30.0906C106.139 30.0906 102.438 26.2491 102.438 21.0131C102.438 15.777 106.142 11.9331 111.388 11.9331ZM111.388 14.6703C107.845 14.6703 105.587 17.3801 105.587 21.0131C105.587 24.6187 107.845 27.3558 111.388 27.3558C114.903 27.3558 117.189 24.6187 117.189 21.0131C117.189 17.3801 114.903 14.6703 111.388 14.6703Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.507 29.7731L126.377 16.9883V29.7731H123.307V12.2236H126.456L135.406 24.671V12.2236H138.476V29.7756H135.507V29.7731Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.198 29.7731V12.2236H145.268V29.7756H142.198V29.7731Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.994 29.7731V12.2236H160.986V14.9335H152.064V19.4846H160.805V22.1944H152.064V27.0632H160.986V29.7731H148.994Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.841 29.7731L170.934 22.9042L166.027 29.7731H162.354L168.914 20.775L162.747 12.2236H166.421L170.934 18.6706L175.423 12.2236H179.124L172.984 20.7502L179.518 29.7756L175.841 29.7731Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2773 10.4994V20.9987L27.2085 15.7478L18.1398 10.4994L27.2085 5.24845L36.2773 0V10.4994Z",
    fill: "#1C3161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1376 21.0013V31.5008L9.06877 26.2498L0 21.0013L9.06877 15.7505L18.1376 10.4995V21.0013Z",
    fill: "#273C6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 10.4989V-0.000488281L9.06877 5.25044L18.1376 10.5014L9.06877 15.7499L0 21.0007V10.4989Z",
    fill: "#7186B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 31.5004V21.001L9.06877 26.252L18.1376 31.5029L9.06877 36.7538L0 41.9997V31.5004Z",
    fill: "#1C3162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2085 15.7505L18.1398 10.4995V20.9989V31.4982L27.2085 36.7492L36.2773 42.0002V31.5008V21.0013L27.2085 15.7505Z",
    fill: "#7086B7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9782_380350"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180.6,
    height: 42,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPoloniex);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/poloniex.a39669166d55dec4bf1fcbf10b1692d1.svg";